RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const TrendsLine = widgets.Chart.extend({
        chartType: RivalIQ.graph.TrendsLine,
        className: 'chart line-chart',
        getChartClassName: function () {

            const me = this;
            return _.head(me.getMetricClassNames());
        },

        getTooltip: function () {
            const me = this;

            return {
                title: function (data, index) {
                    const model = me.collection.first();
                    return model.getDomainName(index);
                },

                content: function (data) {

                    let showJustOne = false;
                    if (RivalIQ.state.utils.isOnlyCompanySet(me.collection.models[0].get('companySetDescriptor'))) {
                        showJustOne = true;
                    }
                    let collection;
                    if (showJustOne) {
                        collection = new RivalIQ.collections.MetricDefinitions(me.collection.tail().map(function (metric, i) {
                            const value = data[0].value[i];

                            return new RivalIQ.models.MetricDefinition(_.extend(metric.toJSON(), {
                                value: metric.format(value),
                                name: RivalIQ.state.landscape.getCompanyById(metric.get('companyId')).get('name')
                            }));
                        }));
                    } else {
                        collection = new RivalIQ.collections.MetricDefinitions(me.collection.map(function (metric, i) {
                            const value = data[0].value[i];

                            return new RivalIQ.models.MetricDefinition(_.extend(metric.toJSON(), {
                                value: metric.format(value)
                            }));
                        }));
                    }

                    const viewOptions = {
                        collection: collection
                    };

                    return new App.widgets.TrendsTooltip(viewOptions).render().el.outerHTML;
                }
            };
        },

        onBeforeShowChart: function (view) {
            const me = this;
            me.listenTo(view, 'analyze-content', _.bind(me.showContentModal, me));
        },

        showContentModal: function (company, timePeriod, index) {
            const me = this;
            const props = me.getProps();
            const model = me.collection.first();
            const mainPeriod = model.getTick(index, {
                format: false
            });
            if (company) {
                props.forName = company.get('name');
            } else {
                props.forName = 'Landscape';
            }
            timePeriod = {
                mainPeriodStart: mainPeriod[0],
                mainPeriodEnd: mainPeriod[1]
            };
            const source = RivalIQ.data.channels.get(props.channel).get('channel');

            // compareAgainst is null
            RivalIQ.apps.SocialPosts.views.PostsModal.show(props, source, company, timePeriod, null);
        },

        getChartAttributes: function () {
            const me = this;

            return _.extend({
                width: me.getProp('width'),
                height: me.getProp('height')
            }, {
                tooltip: (me.getTooltip ? me.getTooltip() : null),
                showComparePeriod: Boolean(me.getProp('showComparePeriod')),
                preferIntegerYTicks: Boolean(me.getProp('preferIntegerYTicks'))
            }, widgets.Chart.prototype.getChartAttributes.apply(me, arguments));
        }
    });

    widgets.MetricTrendsLineChartWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        title: function () {
            const me = this;
            return me.metrics.invoke('getName').join(', ');
        },
        view: TrendsLine,
        processProps: function (props) {
            const me = this;

            if (props.lineChartDimensions) {

                if (me.metrics) {
                    me.metrics = new RivalIQ.collections.MetricDefinitions(me.metrics.map(function (metric) {
                        let dimensions = _.difference(metric.get('dimensions'), _.values(RivalIQ.enums.timePeriod.interval));
                        dimensions = _.union(dimensions, props.lineChartDimensions);

                        // respect export configuration, else update to current focused company id
                        let companyId = metric.get('companyId');
                        const updateCompanyId = !me.curation.isExporting() && companyId;
                        if (updateCompanyId) {
                            companyId = RivalIQ.state.utils.getFocusedCompanyId();
                        }

                        return metric.build({
                            dimensions: dimensions,
                            interval: props.interval,
                            companyId: companyId
                        }, {
                            clobberDimensions: true
                        });
                    }));
                } else {

                    if (props.useAutoTimeInterval) {
                        props.lineChartDimensions = [RivalIQ.metric.timePeriod.getDefaultInterval(props.timePeriod)];
                    }

                    let metric = RivalIQ.metric.pin(RivalIQ.metric.build(props, props.metrics[0]));
                    metric = RivalIQ.metric.build(metric, {
                        dimensions: props.lineChartDimensions
                    });

                    me.metrics = new RivalIQ.collections.MetricDefinitions([metric]);
                }

            } else {
                props = widgets.Chart.buildMetrics(me, props);
            }

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_TRENDS_LINE_CHART, widgets.MetricTrendsLineChartWidget);
});
